export default {
  saved: ['Enregistré !', 'Saved!'],
  created: ['Crée !', 'Created!'],
  deleted: ['Supprimé !', 'Deleted!'],
  loaded: ['Chargé !', 'Loaded!'],
};
